/**
 * Claim detail's two bases (review #397), in a module of its own so the pages' tests
 * that mock claimDetail.ts's fetch keep it.
 */

/**
 * Whether row `i` is a billed claim of the period in a month its owner was paid — every
 * row of a file built before the resolved basis (review #397).
 */
export const billedBasis = (cols: { xb?: readonly (number | null)[] }, i: number) =>
  !cols.xb?.[i]
